import React from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import EmptySection from '../../../../atoms/EmptySection'
import Skeleton from '../../../../atoms/Skeleton'
import { useStatusTemplate } from '../../../../../api/groups'
import { usePolicy } from '../../../../../hooks/usePolicy'
import StatusDetailTabs from './StatusDetailTabs'
import { StatusTemplateProvider } from './StatusTemplateProvider'
import StatusTemplateHeader from './Header'

const useStyles = makeStyles({
  statusTemplatePage: {
    margin: '1rem'
  },
  loadingContainer: {
    width: '100%',
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  },
  headerSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem'
  },
  tabsSkeleton: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1rem'
  },
  contentSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  }
})

const useStatusTemplateId = () => {
  const { templateId } = useParams()
  return isNaN(+templateId) ? [-1] : [+templateId]
}

function StatusTemplateDetails () {
  const classes = useStyles()
  const [statusTemplateId] = useStatusTemplateId()
  const canView = usePolicy('admin_view_status_templates')
  const { data: statusTemplate, isLoading, isFetching } = useStatusTemplate(statusTemplateId)

  if (!canView) {
    return (
      <EmptySection
        title='Access Denied'
        description='You do not have sufficient permissions to access this resource'
      />
    )
  }

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        {/* Header Skeleton */}
        <div className={classes.headerSkeleton}>
          <Skeleton height='36px' width='400px' />
          <Skeleton height='20px' width='600px' />
        </div>

        {/* Tabs Skeleton */}
        <div className={classes.tabsSkeleton}>
          <Skeleton height='40px' width='120px' />
          <Skeleton height='40px' width='180px' />
          <Skeleton height='40px' width='150px' />
          <Skeleton height='40px' width='130px' />
        </div>

        {/* Content Skeleton */}
        <div className={classes.contentSkeleton}>
          <Skeleton height='60px' width='100%' />
          <Skeleton height='60px' width='100%' />
          <Skeleton height='60px' width='100%' />
          <Skeleton height='60px' width='100%' />
          <Skeleton height='200px' width='100%' />
        </div>
      </div>
    )
  }

  if (!statusTemplate) {
    return (
      <EmptySection
        title='Status Template Not Found'
        description=''
      />
    )
  }

  return (
    <div className={classes.statusTemplatePage}>
      <StatusTemplateProvider statusTemplate={statusTemplate} isFetching={isFetching}>
        <StatusTemplateHeader />
        <StatusDetailTabs />
      </StatusTemplateProvider>
    </div>
  )
}

export default StatusTemplateDetails
